export const accountTypeToAPI = {
  '401k': 'accounts/nonGCAccount',
  '403b': 'accounts/nonGCAccount',
  '457': 'accounts/nonGCAccount',
  'payroll-deduct-ira': 'accounts/nonGCAccount',
  '401a': 'accounts/nonGCAccount',
  'keogh': 'accounts/nonGCAccount',
  'sep-ira': 'accounts/nonGCAccount',
  'simple-ira': 'accounts/nonGCAccount',
  // nonGC accounts below used to be personal accounts
  'ira-rollover': 'accounts/nonGCAccount',
  'ira-roth': 'accounts/nonGCAccount',
  'ira-deductible': 'accounts/nonGCAccount',
  'ira-non-deductible': 'accounts/nonGCAccount',
  'brokerage-account': 'accounts/nonGCAccount',
  'annuity-fixed': 'annuity',
  'pension': 'pension',
  'other-asset': 'accounts/nonGCAccount',
}
